import { Component, OnChanges, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';

@Component({
    selector: 'app-view-wo-signatures',
    templateUrl: './view-wo-signatures.component.html',
    styleUrls: ['./view-wo-signatures.component.scss'],
    standalone: false
})


export class ViewWOSignaturesComponent implements OnChanges {

  report = input.required<any>();
  regions: any[] = []

  pageLoaded = false;

  reg = APP_CONSTANTS.URL_REGEX;

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    
  }
  
  ngOnChanges(): void {
    this.findSignatures();
  }

  findSignatures(): void {
    this.regions = ["WO"];
    this.regions = this.regions.map((region: any) => {return {region: region, signature: null}})
    this.report().signatures?.forEach((signature: any) => {
      let region = this.regions.find((region: any) => {
        return region.region == signature.signature
      })
      if (region) {
        region.signature = signature
      }
    })
  }
}
